// extracted by mini-css-extract-plugin
module.exports = {"section":"style-module--section--2HlSr","section__background":"style-module--section__background--_l_bW"};